import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';

interface IProps {
    clearSelections: any;
    viewDetails: any;
    startProduction: any;
    // Splits the orders of the selected row into groups; only a menu that is given it, for one row, has it
    setGrouping?: any;
    rowCount: number;
    heightOffset: number;
}

export const MetricsRightClickMenu = (props : IProps) => {
    return (
        <div>
            <p>Run Actions</p>

            {
                props.rowCount === 1
                    ? <HasPermission requiredPermissions={[
                                Permissions.ProductionMetricsPickupsView, Permissions.ProductionMetricsDeliveriesView
                            ]}>
                                <button onClick={ props.viewDetails }>
                                    <i className="la la-eye"/>
                                    View Orders
                                </button>
                            </HasPermission>
                    : null
            }

            {
                props.rowCount === 1 && props.setGrouping
                    ? <HasPermission requiredPermissions={[
                        Permissions.ProductionMetricsCreateRun
                    ]}>
                        <React.Fragment>
                            <button onClick={ props.setGrouping }>
                                <i className="la la-object-group"/>
                                Set Grouping
                            </button>
                            <div className="right-click-divide" />
                        </React.Fragment>
                    </HasPermission>
                    : null
            }

            <HasPermission requiredPermissions={[
                Permissions.ProductionMetricsCreateRun
            ]}>
                <button onClick={ props.startProduction }>
                    <i className="la la-play-circle"/>
                    Start Production
                </button>
            </HasPermission>

        </div>
    );
};
